window.FichaFinanceiraController = ControllerBase.extend({
    name: "FichaFinanceiraController",

    dataBreadcrumb: new DataBreadcrumb({
        columns: [
            { title: 'CPF/CNPJ', prop: 'CpfCnpj' },
            { title: 'Nome', prop: 'Nome' }
        ],
        getData: function () {

            var cliente = this.cliente
                ? this.cliente
                : ControllerBase.instances['CadastroClienteController'].model;

            return this.toJS(cliente);
        },
    }),

    ajax: function() {
        return {
            url: "/Cliente/_FichaFinanceira",
            type: "post",
            cache: false,
            contentType: "application/json",
            data: global.toJSONString({
                pesquisa: this.pesquisa
            })
        };
    },

    renderizado: function() {

        this.fichaFinanceiraView = this.showView({
            region: {
                name: "fichaFinanceiraViewRegion",
                selector: "#ficha-financeira-region"
            },
            view: {
                type: FichaFinanceiraView,
                args: {
                    model: new FichaFinanceira(this.model)
                }
            }
        });
    }
});